@use '@/styles/tokens' as *;

/* Figma 787:681186 — 12px square, 3px corners, Accent 1/accent-600. Radius 3px has no token; at a
 * 12px edge $radius-sm (4px) is visually identical and keeps the value on the scale.
 *
 * This is the SOLID 600 step, deliberately not the Boundary overlay's own paint — that is the pale
 * 200 step at 0.3 opacity (`boundary-style.ts`), which at 12px would be invisible. Both sit on the
 * accent1 ramp, which is what 113584 §13a's colour match means here. */
.fieldArea {
  display: inline-block;
  flex-shrink: 0;
  border-radius: $radius-sm;
  background: $color-accent1-600;
}

/* The Engine glyph in the SAME red the map's Device pins use — $color-error-700, from Figma
 * 948:567819 via ticket 06's device-markers.module.scss.
 *
 * Figma's own legend leaf (787:681191) binds Error/500 (#FF725C), and the composited 787:678835
 * export confirms the two are genuinely different reds in one frame. 113584 §13a requires the
 * swatch to match the colour used for that element ON THE MAP, and grilling Q1 settles the tie:
 * ACs win, Figma is illustrative. So this follows the pin. The admin twin ported the mismatch and
 * its comment claiming "the same red" is wrong — do not copy it across. Flagged to design. */
.device {
  flex-shrink: 0;
  color: $color-error-700;
}
